export default __webpack_public_path__ + "images/0x7ba6f01772924a82d9626c126347a28299e98c98.png";